module.exports = "/images/visual-e-commerce.png?dec7df9b4aa8ad88a3dbd6defc0cc3b7";